import { render } from "./delivery_note.vue?vue&type=template&id=26b52187&scoped=true"
import script from "./delivery_note.vue?vue&type=script&lang=js"
export * from "./delivery_note.vue?vue&type=script&lang=js"

import "./delivery_note.vue?vue&type=style&index=0&id=26b52187&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b52187"]])

export default __exports__